module.exports = __webpack_public_path__ + "i18n/tr.53f704941aebbda4e797ae2396d18056.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/tr.json
// module id = 856
// module chunks = 60